import PropTypes from 'prop-types';
import { useMemo } from 'react';

import toOfferAdditionalInfosText from 'lib/htmlParsers/parseOfferAdditionalInfos';

const Instructions = ({ allowTextCopy = true, instructions }) => {
  const parsed = useMemo(
    () => (instructions ? toOfferAdditionalInfosText(instructions) : null),
    [instructions]
  );

  return (
    <div
      className={!allowTextCopy ? 'select-none' : null}
      draggable={!allowTextCopy ? true : null}
    >
      {parsed}
    </div>
  );
};

Instructions.propTypes = {
  allowTextCopy: PropTypes.bool,
  instructions: PropTypes.string.isRequired,
};

export default Instructions;
